import useTranslation from 'next-translate/useTranslation'
import Image from 'next/image'
import Teddy from '../../../../../public/assets/our-story/dog-lovers/teddy.jpg'
import TeddyMobile from '../../../../../public/assets/our-story/dog-lovers/teddy-mobile.jpg'
import DogBlob1 from '../../../../../public/assets/illustration-dog-happy-blob.svg'
import DogBlob2 from '../../../../../public/assets/illustration-dog-bowl-blob.svg'
import {
  DogLoversRoot,
  DogLoversTitle,
  DogLoversBody,
  DogLoversImage,
  DogLoversButton,
  DogBlobLeft,
  DogBlobRight,
} from './DogLovers.styles'
import { PhotoCaption } from '../../OurStory.styles'
import Link from 'next/link'

export const DogLovers = ({ isDesktop }: any) => {
  const { t } = useTranslation()
  return (
    <DogLoversRoot id="our-story-2">
      <DogBlobLeft>
        <Image src={DogBlob1} alt="" />
      </DogBlobLeft>
      <DogBlobRight>
        <Image src={DogBlob2} alt="" />
      </DogBlobRight>
      <DogLoversImage>
        <Image src={isDesktop ? Teddy : TeddyMobile} alt="17 year old dog named Teddy" />
        <PhotoCaption position={isDesktop ? 'bottomRight' : 'bottomLarge'}>
          {t('our-story:dog-lovers.photo-caption')}
        </PhotoCaption>
      </DogLoversImage>
      <DogLoversTitle>{t('our-story:dog-lovers.title')}</DogLoversTitle>
      <DogLoversBody>{t('our-story:dog-lovers.body-1')}</DogLoversBody>
      <DogLoversBody>
        {t('our-story:dog-lovers.body-2')}
        <span style={{ fontWeight: 600 }}>{t('our-story:dog-lovers.body-2-bold')}</span>
        {t('our-story:dog-lovers.body-2-cont')}
      </DogLoversBody>
      <DogLoversBody>{t('our-story:dog-lovers.body-3')}</DogLoversBody>
      <Link href="/meal-plan">
        <DogLoversButton>{t('our-story:dog-lovers.button')}</DogLoversButton>
      </Link>
    </DogLoversRoot>
  )
}
